import './App.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Navbar from './components/Navbar';
import CourseCard from './components/CourseCard';
import About from './components/About';
import Banner from './components/Banner';
import Footer from './components/Footer';
import CourseSelector from './components/Category';
import CircleForm from './components/Register';
import LoginForm from './components/Login';
import AboutCourse from './components/AboutCourse';
import Cart from './components/cart';
import { CartProvider } from './Context/Cartcontext';
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./Context/AuthContext";
import Programmes from './components/Programme';
import MyCourse from './components/Mycourse';
import NotFound from "./components/Notfound";
import { BulkRegistration } from './components/BulkRegistration';
import ModernPopup from './components/PaymentSuccess';
import PasswordReset from './components/PasswordReset';
import PaymentFailedPopup from './components/PaymentFailed';

import AnalyticsTracker from "./utility/Analytics";


function Layout() {
  const location = useLocation();

  // Routes to hide exactly
  const hideExact = ["/register", "/login", "/success","/failed"];

  // Dynamic routes that start with these prefixes
  const hideDynamic = ["/pass-reset/"];

  const isExactHide = hideExact.includes(location.pathname);

  const isDynamicHide = hideDynamic.some(route =>
    location.pathname.startsWith(route)
  );

  const shouldHideNavbar = isExactHide || isDynamicHide;

  return (
    <>
      {!shouldHideNavbar && <Navbar />}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/courses" element={<CourseSelector />} />
        <Route path="/register" element={<CircleForm />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/programs" element={<Programmes />} />
        <Route path="/cart" element={<Cart />} />
        {/* <Route path="/about-course/:slug" element={<AboutCourse />} /> */}
      
  <Route path="/about-course/:id" element={<AboutCourse />} />
        <Route path="/mycourse" element={<MyCourse />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/bulkregistration" element={<BulkRegistration />} />
        <Route path="/pass-reset/:id" element={<PasswordReset />} />
        <Route path="/success" element={<ModernPopup />} />
        <Route path="/failed" element={<PaymentFailedPopup/>} />
      </Routes>

      {!shouldHideNavbar && <Footer />}
    </>
  );
}


function HomePage() {
  return (
    <>
      <title>EDC Learning – Online Courses for Skill Development</title>
      <meta name="description" content="Learn professional and industry-ready courses from EDC Learning. Upgrade your skills in technology, business, soft skills, and more." />
      <meta name="keywords" content="courses, learning, edc, education, skills" />
      <meta property="og:title" content="Courses - EDC Learning" />
      <meta property="og:description" content="Find the right course to upskill yourself." />
      <meta property="og:image" content="/images/LSClogo.png" />
      <meta property="og:url" content="https://edc.lsc-india.org/" />
      <meta name="twitter:card" content="summary_large_image" />
      <Banner />
      <About />
      <CourseCard />
    </>
  );
}

function App() {
  return (
    <>
    <title>EDC Learning – Online Courses for Skill Development</title>
      <meta name="description" content="Learn professional and industry-ready courses from EDC Learning. Upgrade your skills in technology, business, soft skills, and more." />
      <meta name="keywords" content="courses, learning, edc, education, skills" />
      <meta property="og:title" content="Courses - EDC Learning" />
      <meta property="og:description" content="Find the right course to upskill yourself." />
      <meta property="og:image" content="/images/LSClogo.png" />
      <meta property="og:url" content="https://edc.lsc-india.org/" />
      <meta name="twitter:card" content="summary_large_image" />
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <HelmetProvider>
            <BrowserRouter>
             <AnalyticsTracker>
              <Layout />
              </AnalyticsTracker>
            </BrowserRouter>
          </HelmetProvider>
        </CartProvider>
      </AuthProvider>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
    </>
  );
}

export default App;
